import React, { useEffect, useRef, useState } from 'react';
// import Swiper from 'react-id-swiper';

import SwiperCore, {
  Navigation,
  Scrollbar,
  Autoplay
} from 'swiper';
import { Swiper } from 'swiper/react';
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

// install Swiper modules
SwiperCore.use([Navigation, Scrollbar, Autoplay]);

const Slideshow = ({ children, params, initialSlide, autoplay, slidesPerView }) => {

  // const defaultParams = {
  //   // pagination: {
  //   //   el: '.swiper-pagination',
  //   //   type: 'bullets',
  //   //   clickable: true
  //   // },
  //   activeSlideKey: initialSlide,
  //   // initialSlide: initialSlide,
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev'
  //   },
  //   spaceBetween: 30,
  //   autoplay: {
  //       // delay: autoplay || 10000
  //       delay: 10000
  //   },
  //   loop: true,
  //   renderPrevButton: () => (
  //     <div className="swiper-button-prev">
  //       {/* <Icon name="arrow left" /> */}
  //     </div>
  //   ),
  //   renderNextButton: () => (
  //     <div className="swiper-button-next">
  //       {/* <Icon name="arrow right" /> */}
  //     </div>
  //   ),
  // }
  const [swiper, setSwiper] = useState(null);

  const initSwiper = (newSwiper) => {
    setSwiper(newSwiper)
  }

  const defaultParams = {
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 30
}

  const swiperRef = useRef(null)

  useEffect(() => {

    console.log(initialSlide, children.length)

    if(swiper) swiper.slideTo(initialSlide < children.length ? initialSlide+1 : 0, 0)

  })

  // TODO Fix Slideshow
  // auto slide!!

  return (
    <>
      <Swiper
      spaceBetween={0}
      slidesPerView={slidesPerView || 1}
      onSlideChange={(e) => {
        // console.log('slide change')
        if(swiperRef.current) {
          console.log(e.activeIndex, e.$wrapperEl[0])

          const getActiveChild = e.$wrapperEl[0].childNodes[e.activeIndex]
          const activeVideo = getActiveChild.querySelector('video')
          const activeAudio = getActiveChild.querySelector('audio')
          const activeMediaItem = activeVideo || activeAudio
          // console.log('activeMediaItem', activeMediaItem)

          const AudioEls = swiperRef.current.querySelectorAll('audio')
          const VideoEls = swiperRef.current.querySelectorAll('video')

          AudioEls.forEach(audioEl => audioEl.pause())
          VideoEls.forEach(videoEl => videoEl.pause())

          // if(activeVideo) activeVideo.play()
          if(activeMediaItem) activeMediaItem.play()
        }
      }}
      onSwiper={(newSwiper) => initSwiper(newSwiper)}
      scrollbar={{ draggable: true }}
      navigation
      // navigation={{
      //   navigation: {
      //     nextEl: ".review-swiper-button-next",
      //     prevEl: ".review-swiper-button-prev",
      //   },
      // }}
      // autoPlay={{ delay: 1000 }}
      // autoplay={{ delay: 10000 }}
      loop={true}
      // params={{
      //   ...defaultParams, 
      // }}
      ref={swiperRef}>
        {children}
      </Swiper>
      {/* <style>{`
        .swiper-container{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
        }

        .swiper-button-next, .swiper-button-prev{
          position: fixed;
          height: 100%;
          // background: red;
          top: 0;
          width: 20%;
          margin: 0;
          z-index: 100;
          cursor: pointer;
          color: white;
        }
        .swiper-button-next:after, .swiper-button-prev:after{
          color: white;
        }

        .swiper-button-prev{
            left: 0;
        }
        .swiper-button-next{
            right: 0;
        }

        .swiper-button-next::after, .swiper-button-prev::after{
            display: none;
        }
    `}</style> */}
    </>
  )
}

export default Slideshow